module.exports = __webpack_public_path__ + "img/drive.39b53e1a.png";